export const specialCharacters = '!@#$%^&*()_+{}|:"<>?[];\',./{^?}~`';